import dayjs from 'dayjs';

import isToday from 'dayjs/plugin/isToday';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('MST');
dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(localizedFormat);

export default dayjs;
